import React, { useState } from "react";
import { Modal } from "@mui/material";
import { showToast } from "../../../../utils/Toast";
import { validatePaymentDetails } from "../../../payment/validatePayment";
import PaymentForm from "../../../payment/PaymentForm";
import { reportPaymentValue } from "../../../../utils/constant";
import logo from "../../../../assets/lux-logo/bidcaribbeansBlueLogo.jpg";
import CarPreview from "./CarPreview";
import useGetCarReport from "../../../../hooks/useGetCarReport";

const ReportPreview = ({ vin }) => {
  const [openModal, setOpenModal] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState({
    card_name: "",
    card_number: "",
    card_cvv: "",
    card_exp: "",
    card_amount: reportPaymentValue,
    email: "",
    paymentPurpose: "Report Payment",
  });
  const [errors, setErrors] = useState({});

  const {
    fetchCarReport,
    loading: reportFetchLoading,
    error: reportError,
  } = useGetCarReport();

  const handleGetReport = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setPaymentDetails({
      card_name: "",
      card_number: "",
      card_cvv: "",
      card_exp: "",
      card_amount: reportPaymentValue,
      email: "",
      paymentPurpose: "Report Payment",
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPaymentDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const newErrors = validatePaymentDetails(paymentDetails);
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      const pdfUrl = await fetchCarReport(vin, paymentDetails);

      if (pdfUrl) {
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = `CarReport_${vin}.pdf`;
        link.click();

        showToast("Report Downloaded Successfully", "success");
        handleCloseModal();
      } else {
        showToast(reportError || "Failed to fetch report", "error");
      }
    }
  };

  return (
    <>
      <CarPreview vin={vin} onGetReport={handleGetReport} />

      <Modal open={openModal} onClose={handleCloseModal}>
        <div
          className="bg-white p-6 rounded-lg shadow-lg w-[90vw] md:w-[600px] lg:w-[700px] max-h-[90vh] overflow-y-auto"
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <div className="bg-[#008b98] rounded-lg w-full">
            <img
              src={logo}
              alt="Company Logo"
              className="w-[25%] h-auto mx-auto"
            />
          </div>

          <PaymentForm
            paymentDetails={paymentDetails}
            handleInputChange={handleInputChange}
            errors={errors}
            onSubmit={handleSubmit}
            closeModal={handleCloseModal}
            loading={reportFetchLoading}
            cardAmount={reportPaymentValue}
          />
        </div>
      </Modal>
    </>
  );
};

export default ReportPreview;
